<template>
  <section class="row">
    <div class="col-12">
      <div
        v-if="loading"
        class="col text-center">
        <coozzy-spinner />
      </div>
      <div
        v-if="!loading && !url && !hasSeveralUrls && !fromOwnerBase"
        class="col d-flex justify-content-center align-items-center font-weight-bold h1">
        n/a
      </div>
      <div
        v-if="!loading && hasSeveralUrls && !selectedElement"
        class="row report-cards">
        <template>
          <template
            v-for="(item, index) in listReports">
            <div
              :key="index"
              class="col-12 col-md-6 col-lg-4 mb-3">
              <report-card
                :report="item"
                @open-selected-report="reportingSelected" />
            </div>
          </template>
        </template>
      </div>
      <div
        v-else-if="url"
        class="col">
        <iframe
          :id="'reporting-' + replaceURL(url)"
          :key="url"
          :src="url"
          style="min-width: 100%; border: none; min-height: 92vh;"
          allowtransparency />
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import ReportingApi from '@/misc/apis/ReportingApi'
import { user } from '@/mixins/user'
import CoozzySpinner from '@/framework/components/misc/CoozzySpinner.vue'
import Vue from 'vue'
import { ReportingReportingUrl } from '@/types/api'
import ReportCard from '@/reporting/ReportCard.vue'

export default Vue.extend({
  name: 'ReportingView',
  components: {
    ReportCard,
    CoozzySpinner
  },
  mixins: [user],
  props: {
    selectedElement: {
      type: [String, Number],
      required: false,
      default: ''
    },
    fromOwnerBase: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  metaInfo() {
    return {
      title: this.$t('message.reporting.titles.overview')
    }
  },
  data() {
    return {
      loading: false as boolean,
      defaultReportings: [] as ReportingReportingUrl[],
      additionalReportings: [] as ReportingReportingUrl[],
      url: '' as string,
      messageHandler: null as ((event: MessageEvent) => void) | null
    }
  },
  computed: {
    hasSeveralUrls() {
      return this.listReports.length > 0
    },
    listReports() {
      return [...this.defaultReportings, ...this.additionalReportings]
    }
  },
  watch: {
    selectedElement(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.$nextTick(() => {
          this.url = newVal
        })
      }
    }
  },
  mounted() {
    this.loading = true
    this.messageHandler = (event: MessageEvent) => {
      const data = event.data
      if (data.type === 'ic3-custom-headers-request') {
        const embeddedDiv = (data.ic3callerType === 'div')

        const target = !embeddedDiv
            ? (document.getElementById('reporting-' + this.replaceURL(this.url)) as HTMLIFrameElement)?.contentWindow
            : window

        target && target.postMessage(
            {
              type: 'ic3-custom-headers-reply',
              data: {
                headers: {
                  Authorization: `Bearer ${this.getAccessToken}`
                }
              }
            },
            '*'
        )
      }
    }
    window.addEventListener('message', this.messageHandler)
    ReportingApi.getMyReportings()
      .then(response => {
        this.defaultReportings = response.defaultReportings
        this.additionalReportings = response.additionalReportings
        setTimeout(() => {
          this.loading = false
          if (this.selectedElement) {
            this.url = this.selectedElement as string
          }
        }, 1000)
      })
      .catch(e => {
        if (e.response.status !== 404) {
          Vue.toasted.show(this.$t('message.loadingErrors.reporting'), { type: 'error' })
          console.error(e)
        }
        this.loading = false
      })
  },
  beforeDestroy() {
    if (this.messageHandler) {
      window.removeEventListener('message', this.messageHandler)
    }
  },
  methods: {
    reportingSelected(item: ReportingReportingUrl): void {
      if (!item.url) {
        Vue.toasted.show('The report has no URL', { type: 'error' })
        return
      }
      this.$router.push({
        name: this.$route.name,
        query: {
          selectedElement: item.url
        }
      })
    },
    replaceURL(url: string): string {
      return url.replace(/[^a-zA-Z0-9]/g, '')
    }
  }
})
</script>

<style lang="scss" scoped>
.logo {
  display: block;
  width: 100%;
  height: 208px;
  object-fit: contain;
}

.single-name {
  height: 100%;
  text-align: center;
}

iframe {
  overflow-x: hidden;
  overflow-y: hidden;
}
@media (max-width: 991px) {
 .report-cards {
    margin-bottom: 150px;
  }
}
</style>
